import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-homeone-video',
    templateUrl: './homeone-video.component.html',
    styleUrls: ['./homeone-video.component.scss']
})
export class HomeoneVideoComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}

    // Video Popup
    isOpen = false;
    openPopup(): void {
        this.isOpen = true;
    }
    closePopup(): void {
        this.isOpen = false;
    }

}